import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import {
  BrowserWorkflowApiConfiguration,
  IBrowserWorkflowApiConfigurationParams,
} from './browser-workflow-api-configuration';

@NgModule()
export class BrowserWorkflowApiModule {
  constructor(@Optional() @SkipSelf() parentModule: BrowserWorkflowApiModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('WorkflowApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }

  static forRoot(params: IBrowserWorkflowApiConfigurationParams): ModuleWithProviders<BrowserWorkflowApiModule> {
    return {
      ngModule: BrowserWorkflowApiModule,
      providers: [{ provide: BrowserWorkflowApiConfiguration, useValue: params }],
    };
  }
}
